module.exports = __webpack_public_path__ + "img/17.aaf637a.png";